@import 'src/global/media_queries'
  
:host 
  display: block

  svg
    display: block
    margin: 1rem auto 0

    &.process-desktop
      display: none
      width: 60%
      min-width: 35rem

      @include media(">=tablet")
        display: block

    &.process-mobile
      display: block
      max-width: 300px
      width: 75%

      @include media(">=tablet")
        display: none

